module.exports = __webpack_public_path__ + "media/images/sample/draft-36a714332f7a63f95daa85c384d530b9.jpg";